module.exports = __webpack_public_path__ + "img/dental-technician-working@2x.93f006ab.png";